angular.module('contactModule').component('contactPartialBeds', {
	templateUrl: 'contactPartialBeds/contactPartialBeds.html',
	bindings: {
		bedrooms: '<',
		isMobile: '<'
	},
	controller: ['$timeout', '$window', 'PubSub', '$element', 'crResourcesService', function($timeout, $window, PubSub, $element, crResourcesService) {
		var ctrl = this;

		this.$onInit = () => {
			this.checkboxesBedrooms = this.bedrooms;	
		};

		this.$postLink = () => {
	
		};


		this.toggleValue = function(checkbox) {
			checkbox.value = !checkbox.value;
		};

	}]
});